import { Colors } from "@/enums/Colors";
import { SxProps } from "@mui/material";

export const UserAvatarSx: SxProps = {
  borderRadius: "0.5rem",
  backgroundColor: "#fff",
  backgroundImage: "none",
  border: `1px solid ${Colors.LIGHT_GRAY_DEDEE1}`,
  color: Colors.ELEGANT_BLACK,
  fontSize: "1.125rem",
};

export const ClickableTextSx: SxProps = {
  display: "inline-block",
  position: "relative",
  cursor: "pointer",
  transition: "color 0.25s ease-out",
  "&::after": {
    content: '""',
    position: "absolute",
    width: "100%",
    transform: "scaleX(0)",
    height: "1px",
    bottom: -2,
    left: 0,
    backgroundColor: Colors.LAZO_PURPLE,
    transformOrigin: "bottom left",
    transition: "transform 0.25s ease-out",
  },
  "&:hover": {
    color: Colors.LAZO_PURPLE,
    "&::after": {
      transform: "scaleX(1)",
    },
  },
  "&::before": {
    content: '""',
    position: "absolute",
    width: "50%",
    height: "1px",
    bottom: -2,
    left: 0,
    backgroundColor: "rgba(0, 0, 0, 0.2)",
    transform: "scaleX(1)",
  },
};
